import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Footer from './Footer'

export default function PageLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-black font-sans text-white selection:bg-gold-500 selection:text-black">
      <nav className="sticky top-0 z-40 flex items-center justify-between border-b border-white/10 bg-black/95 p-6 backdrop-blur-sm">
        <Link to="/" className="group flex items-center gap-2 text-white/80 transition-colors hover:text-gold-400">
          <ArrowLeft className="h-5 w-5 transition-transform group-hover:-translate-x-1" aria-hidden="true" />
          <span className="text-sm uppercase tracking-widest">Back to Home</span>
        </Link>
        <Link to="/" className="text-xl font-serif tracking-widest text-gold-400">SAATBAHANE</Link>
        <div className="w-24" aria-hidden="true" />
      </nav>
      <main className="mx-auto max-w-4xl px-6 py-16">
        <h1 className="mb-12 border-l-4 border-gold-500 pl-6 text-4xl font-serif text-white md:text-5xl">{title}</h1>
        <div className="legal-content max-w-none text-lg text-white/80">{children}</div>
      </main>
      <Footer />
    </div>
  )
}
